module.exports = __webpack_public_path__ + "static/media/pestoroastedchickensalad.3bee1733.jpeg";